import { gql } from "@apollo/client";

const GET_REMITTANCE_ITEM_WITH_INCOMPLETE_DEDUCTIONS = gql`
  query GetRemittanceItemsWithIncompleteDeductions($params: GetRemittanceWithIncompleteDeductionsParams!) {
    remittanceItemsWithIncompleteDeductions(params: $params) {
      total
      page
      columns {
        key
        title
      }
      limit
      items {
        checkNo
        invoiceNo
        invoiceDate
        age
        grossAmount
        netAmount
        discountAmount
        purchaser {
          purchaserId
          purchaserName
          purchaserKey
        }
        remittanceId
        remittanceItemId
        description
        isDeduction
        isBackupRequested
        canRequestBackup
      }
    }
  }
`;

export default GET_REMITTANCE_ITEM_WITH_INCOMPLETE_DEDUCTIONS;
